// src/analytics/gtag.js
export const GA_MEASUREMENT_ID = 'G-RWQLGHMR5T';

function safeGtag(...args) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(args);
  }
}

/** Send a page_view event manually for React Router navigation */
export function pageview(path, title) {
  safeGtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href
  });
}

/** Generic event helper */
export function event(name, params = {}) {
  safeGtag('event', name, params);
}

/** Optional: set user ID (must not contain PII like email) */
export function setUserId(id) {
  if (id) safeGtag('set', { user_id: id });
}

/** Optional: set custom user properties */
export function setUserProperties(properties = {}) {
  safeGtag('set', { user_properties: properties });
}
